import './App.css';
import { Header } from './My Components/Header';
import { TextArea } from './My Components/TextArea';
import { Footer } from './My Components/Footer';
import React, { useState } from 'react'
import Alert from './My Components/Alert';
// import { About } from './My Components/About';
// import {
//   BrowserRouter as Router,
//   Routes,
//   Route,
//   Link
// } from "react-router-dom";


function App() {
const [mode, setmode] = useState('light');
const [alert, setAlert] = useState(null);

const showAlert = (type, message) =>{
  setAlert({
    type: type,
    msg : message,
  })
  setTimeout(() => {
    setAlert(null)
  }, 2000);
}

const toggleMode = () =>{
  if(mode === 'light'){
    setmode('dark');
    document.body.style.background = '#060e37';
    // showAlert("success","Dark mode has been enabled");
  }else {
    setmode('light');
    document.body.style.background = 'white';
    // showAlert("success","Light mode has been enabled");
  }
}


  return (
    <>
    {/* <Router> */}
      <Header title = "TextUtils" mode={mode}/>
        <Alert alert={alert}/>
        {/* <Routes> */}
        {/* <Route exact path="/about" element={<About toggleMode = {toggleMode} mode = {mode}/>}/> */}
        <TextArea toggleMode = {toggleMode} mode = {mode} showAlert = {showAlert}/>
    {/* </Routes> */}
        <Footer/>
              
      {/* </Router> */}
    </>
  );
}

export default App;
